module.exports = __webpack_public_path__ + "static/media/zole_logo.ab72bab8.webp";